import { IActivityLog } from "../../../../util/varibles/interface";

export default function TravellingToSite({ log }: { log: IActivityLog }) {
    console.log(log.key)
    return <div></div>
}